(()=>{
  const GLOBAL_KEY="__saltiqueLabFlowRuntime";
  if(window[GLOBAL_KEY]){window[GLOBAL_KEY].bootAll();return}

  const clamp=(value,min=0,max=1)=>Math.min(max,Math.max(min,value));
  const stops=[
    [0,[235,228,216]],
    [.24,[204,214,205]],
    [.5,[86,118,108]],
    [.76,[45,63,58]],
    [1,[34,31,27]]
  ];

  const mix=p=>{
    p=clamp(p);
    let a=stops[0],b=stops[stops.length-1];
    for(let i=0;i<stops.length-1;i++){
      if(p>=stops[i][0]&&p<=stops[i+1][0]){a=stops[i];b=stops[i+1];break}
    }
    const t=(p-a[0])/(b[0]-a[0]||1);
    return a[1].map((v,i)=>Math.round(v+(b[1][i]-v)*t));
  };

  const instances=new WeakMap();

  function init(root){
    if(!root||instances.has(root))return;
    document.body.classList.add("sq-lab-page");

    const controller=new AbortController();
    const signal=controller.signal;
    const rays=root.querySelector("[data-rays]");
    const foam=root.querySelector("[data-foam]");
    const snow=root.querySelector("[data-snow]");
    const chrome=root.querySelector("[data-chrome]");
    const marker=root.querySelector("[data-marker]");
    const zone=root.querySelector("[data-zone]");
    const meters=root.querySelector("[data-meters]");
    const hint=root.querySelector("[data-hint]");
    const labLink=root.querySelector(".sq-labflow__lablink");
    const stageEls=[...root.querySelectorAll("[data-sq-stage]")];
    const pageWrapper=root.closest(".page-wrapper");
    let scrollContainer=window;
    let rootTop=0;
    let stages=[];
    let raf=0;

    function resolveScrollContainer(){
      if(!pageWrapper)return window;
      const style=getComputedStyle(pageWrapper);
      const scrollable=/(auto|scroll|overlay)/.test(style.overflowY)
        && pageWrapper.scrollHeight>pageWrapper.clientHeight+1;
      return scrollable?pageWrapper:window;
    }

    function getScrollTop(){
      return scrollContainer===window?window.scrollY:scrollContainer.scrollTop;
    }

    function measure(){
      scrollContainer=resolveScrollContainer();
      const rect=root.getBoundingClientRect();
      if(scrollContainer===window){
        rootTop=window.scrollY+rect.top;
      }else{
        const containerRect=scrollContainer.getBoundingClientRect();
        rootTop=scrollContainer.scrollTop+rect.top-containerRect.top;
      }
      stages=stageEls
        .map(el=>({
          y:el.offsetTop,
          depth:Number(el.dataset.depth)||0,
          zone:el.dataset.zoneName||""
        }))
        .sort((a,b)=>a.y-b.y);
    }

    function getDepthState(localY){
      if(stages.length<2){
        const range=Math.max(1,root.scrollHeight-window.innerHeight);
        const q=clamp(localY/range);
        return{depth:q*40,zone:q<.3?"The shore":q<.6?"The shallows":q<.9?"The deep":"The seabed"};
      }
      if(localY<=stages[0].y)return{depth:stages[0].depth,zone:stages[0].zone};
      for(let i=0;i<stages.length-1;i++){
        const a=stages[i],b=stages[i+1];
        if(localY<b.y){
          const t=clamp((localY-a.y)/Math.max(1,b.y-a.y));
          return{depth:a.depth+(b.depth-a.depth)*t,zone:a.zone};
        }
      }
      const last=stages[stages.length-1];
      return{depth:last.depth,zone:last.zone};
    }

    function render(){
      const localY=getScrollTop()-rootTop;
      const state=getDepthState(localY);
      const q=clamp(state.depth/40);
      const top=mix(Math.max(0,q-.13));
      const bottom=mix(q);

      root.style.setProperty("--sq-water-top",`rgb(${top.join(",")})`);
      root.style.setProperty("--sq-water-bottom",`rgb(${bottom.join(",")})`);
      root.dataset.sqReady="true";

      if(rays){
        rays.style.opacity=String(Math.max(0,1-q*1.55));
        rays.style.transform=`translateY(${q*80}px) scale(${1+q*.1})`;
      }
      if(foam){
        foam.style.opacity=String(Math.max(0,1-q*3));
        foam.style.transform=`translateY(${-q*180}px)`;
      }
      if(snow)snow.style.opacity=String(clamp((q-.32)*1.8,0,.9));
      if(chrome)chrome.style.color=q<.4?"#283b36":"#f7f4ee";
      if(marker)marker.style.top=`${6+q*88}%`;
      if(meters)meters.textContent=`${Math.round(state.depth)} m`;
      if(zone)zone.textContent=state.zone;
      if(hint)hint.style.opacity=String(Math.max(0,1-q*9));
      raf=0;
    }

    function scheduleRender(){
      if(!raf)raf=requestAnimationFrame(render);
    }

    function remeasure(){
      measure();
      scheduleRender();
    }

    function scrollToTarget(target,behavior){
      if(!target)return;
      scrollContainer=resolveScrollContainer();
      const reduced=matchMedia("(prefers-reduced-motion: reduce)").matches;
      const scrollBehavior=behavior||(reduced?"auto":"smooth");
      const targetRect=target.getBoundingClientRect();
      if(scrollContainer===window){
        window.scrollTo({top:window.scrollY+targetRect.top,behavior:scrollBehavior});
      }else{
        const containerRect=scrollContainer.getBoundingClientRect();
        scrollContainer.scrollTo({
          top:scrollContainer.scrollTop+targetRect.top-containerRect.top,
          behavior:scrollBehavior
        });
      }
    }

    measure();
    render();

    window.addEventListener("scroll",scheduleRender,{passive:true,signal});
    pageWrapper?.addEventListener("scroll",scheduleRender,{passive:true,signal});
    window.addEventListener("resize",remeasure,{passive:true,signal});

    const resizeObserver="ResizeObserver" in window?new ResizeObserver(remeasure):null;
    resizeObserver?.observe(root);

    labLink?.addEventListener("click",event=>{
      const target=root.querySelector("#sq-proof");
      if(!target)return;
      event.preventDefault();
      scrollToTarget(target);
      if(location.hash!=="#sq-proof")history.pushState(null,"","#sq-proof");
    },{signal});

    if(location.hash==="#sq-proof"){
      const proof=root.querySelector("#sq-proof");
      if(proof)requestAnimationFrame(()=>scrollToTarget(proof,"auto"));
    }

    root.querySelectorAll("[data-shell]").forEach((shell,index)=>{
      const button=shell.querySelector("button");
      if(!button)return;
      button.addEventListener("click",()=>{
        const opening=!shell.classList.contains("is-open");
        root.querySelectorAll("[data-shell].is-open").forEach(other=>{
          if(other!==shell){
            other.classList.remove("is-open");
            other.querySelector("button")?.setAttribute("aria-expanded","false");
          }
        });
        shell.classList.toggle("is-open",opening);
        button.setAttribute("aria-expanded",String(opening));
        window.dataLayer?.push({event:"saltique_lab_shell_toggle",shell_index:index+1,shell_state:opening?"open":"closed"});
      },{signal});
    });

    document.addEventListener("keydown",event=>{
      if(event.key!=="Escape")return;
      root.querySelectorAll("[data-shell].is-open").forEach(shell=>{
        shell.classList.remove("is-open");
        shell.querySelector("button")?.setAttribute("aria-expanded","false");
      });
    },{signal});

    const form=root.querySelector("[data-lot-form]");
    const report=root.querySelector("[data-report]");
    const copy=root.querySelector("[data-report-copy]");
    const reset=root.querySelector("[data-reset]");

    form?.addEventListener("submit",event=>{
      event.preventDefault();
      const value=form.elements.lot?.value.trim();
      if(copy)copy.textContent=value
        ?`No published certificate currently matches “${value}”. Foundi's independent testing programme is still being built, and no illustrative result is being presented as a real product report.`
        :"Enter the lot code printed on a tested bag. Certificates will appear here after independent analysis and publication.";
      report?.classList.add("is-visible");
      report?.scrollIntoView({
        behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",
        block:"nearest"
      });
      window.dataLayer?.push({event:"saltique_lab_lot_lookup",result:value?"no_certificate":"empty"});
    },{signal});

    reset?.addEventListener("click",()=>{
      form?.reset();
      report?.classList.remove("is-visible");
      form?.querySelector("input")?.focus();
    },{signal});

    instances.set(root,{
      destroy(){
        controller.abort();
        resizeObserver?.disconnect();
        if(raf)cancelAnimationFrame(raf);
        instances.delete(root);
      }
    });
  }

  function bootWithin(container){
    if(container?.matches?.("[data-sq-labflow]"))init(container);
    container?.querySelectorAll?.("[data-sq-labflow]").forEach(init);
  }

  function bootAll(){
    document.querySelectorAll("[data-sq-labflow]").forEach(init);
    if(document.querySelector("[data-sq-labflow]"))document.body.classList.add("sq-lab-page");
  }

  function destroyWithin(container){
    const roots=[];
    if(container?.matches?.("[data-sq-labflow]"))roots.push(container);
    container?.querySelectorAll?.("[data-sq-labflow]").forEach(root=>roots.push(root));
    roots.forEach(root=>instances.get(root)?.destroy());
    if(!document.querySelector("[data-sq-labflow]"))document.body.classList.remove("sq-lab-page");
  }

  const runtime={bootAll,bootWithin,destroyWithin};
  window[GLOBAL_KEY]=runtime;

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",bootAll,{once:true});
  }else{
    bootAll();
  }
  document.addEventListener("shopify:section:load",event=>bootWithin(event.target));
  document.addEventListener("shopify:section:unload",event=>destroyWithin(event.target));
  window.addEventListener("pageshow",bootAll);
  window.addEventListener("pagehide",()=>document.body.classList.remove("sq-lab-page"));
})();